
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'


import Vue from "vue";

export default {
components: {
XHeader,
Tab,
TabItem,
CheckIcon,
Flexbox,
FlexboxItem,
Group,
XInput,
XButton,
Icon,
Cell,
LoadMore
},
data() {
return {
isDropping:false,
title: this.$route.query.title,
subjectList: [],
isSubjectLoadMore: false,
isShowSubjectLoadMore: false,
showtime: this.$route.query.showtime, //0练习 1模考 2查看解析 3模考的错题重做 4在收藏列表中练习 5在错误列表中练习 6在笔记列表中练习 8艾宾浩斯
chapterId: this.$route.query.chapterid, //章节编号
errtype: this.$route.query.errtype, //错题类型 1:待解决 2已解决
errobj: this.$route.query.errobj, //错题对象 0章节 1次数 2周期
errvalue: this.$route.query.errvalue 
};
},
created() {
this.LoadSubjectList();
},

methods: {
initData() {
this.showtime = this.$route.query.showtime; 
this.chapterId =this.$route.query.chapterid; 
this.errtype =this.$route.query.errtype; 
this.errobj =this.$route.query.errobj; 
this.errvalue = this.$route.query.errvalue ;

this.isShowSubjectLoadMore = false;
this.LoadSubjectList();
},
LoadSubjectList() {
this.$vux.loading.show({
text: "请稍候..."
});
this.subjectList = [];
console.log("LoadSubjectList",  this.$route.query.chapterid, this.showtime);
this.$http({
method: "post",
url: "wxexam.ashx?op=LoadSubjectList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
chapterId: this.chapterId,
showTime: this.showtime,
showtype: 1,
errtype: this.errtype,
errobj: this.errobj,
errvalue: this.errvalue
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
response.data.data.forEach(subject => {
subject.ctitle = subject.ctitle.replace(/<img(.*?)>/ig, "【图】");
this.subjectList.push(subject);
});
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
onSubjectClick(subjectItem) {
if(this.isDropping) return;
var listId = Date.parse(new Date());
var stroageSubjectList = {
id: listId,
list: this.subjectList
};
sessionStorage.setItem("subjectList", JSON.stringify(stroageSubjectList));

this.$router.push({
path: "/SubjuectData",
query: {
subjectid: subjectItem.isubjectid,
showtime: this.showtime,
listid: listId
}
});
},
onSubjectMore() {
this.isSubjectLoadMore = true;
this.searchSubjectList(true);
},
doStartDrop(){
this.isDropping = true;
},

doCancelDrop(){
this.isDropping = false;
},
doSelectAll(){
this.subjectList.forEach(subject => {
Vue.set(subject, "bselected", true)
});
},
doSelectNone(){
this.subjectList.forEach(subject => {
Vue.set(subject, "bselected", false)
});
},
doDropSubject(){
var hadselected = false;
this.subjectList.forEach(subject => {
if(subject.bselected){
hadselected = true;
return;
}
});
if(!hadselected){
this.$vux.toast.text("请先选择要删除的记录", "bottom");
return;
}
const _this = this;
this.$vux.confirm.show({
title: "确认删除",
content: "确定要删除选中的记录吗？",
confirmText: "确认删除",
cancelText: "先不要",
onConfirm() {

_this.subjectList.forEach(subject => {
if(subject.bselected){
if(_this.showtime == 4)
_this.DoDeleteCollectSubject(subject);
else if(_this.showtime == 5)
_this.DoDeleteWrongSubject(subject);
else if(_this.showtime == 6)
_this.DoDeleteNotedSubject(subject);
}
});
for(var i=_this.subjectList.length - 1;i>=0;i--){
if(_this.subjectList[i].bselected){
_this.subjectList.splice(i, 1);
}
}
_this.doCancelDrop();
},
});
},

DoDeleteWrongSubject(subject){
this.$http({
method: "post",
url: "wxexam.ashx?op=DoDeleteWrongSubject",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subject.isubjectid,
clearWrongcount: true
}
})
.then(response => {
;
})
.catch(function(error) {
console.log("error:" + error);
});
},
DoDeleteCollectSubject(subject){
this.$http({
method: "post",
url: "wxexam.ashx?op=DoDeleteCollectSubject",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subject.isubjectid
}
})
.then(response => {
;
})
.catch(function(error) {
console.log("error:" + error);
});
},
DoDeleteNotedSubject(subject){
this.$http({
method: "post",
url: "wxexam.ashx?op=WriteSubjectNote",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subject.isubjectid,
noteText:"",
}
})
.then(response => {
;
})
.catch(function(error) {
console.log("error:" + error);
});
},
},
watch: {
$route(to, from) {
if ((from.path == "/ErrorList" || from.path == "/WriteNoteList") && to.path == "/ChapterSubjectList") {

this.initData();
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/ChapterSubjectList.vue